import {
  ChangeDetectionStrategy, Component, ElementRef, HostBinding, OnInit, Renderer2,
  ViewEncapsulation
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { AnimationCurves, AnimationDurations } from '../../../core/animation/animation';

@Component({
  selector: 'mcrai-toast',
  template: `<span class="mcrai-toast__text">
  {{ text }}
</span>

`,
  styles: [`.mcrai-toast{display:flex;align-items:center;justify-content:center;height:60px;margin:0 10px;padding:0 20px}.mcrai-toast__text{font-size:16px}`],
  animations: [
    trigger('slide', [
      state('void', style({
        opacity: 0,
        transform: 'translateY({{ offsetY }})'
      }), {
        params: {
          offsetY: '60px'
        }
      }),
      state('visible', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      state('hidden', style({
        opacity: 0,
        transform: 'translateY({{ offsetY }})'
      }), {
        params: {
          offsetY: '60px'
        }
      }),
      transition('* => visible',
        animate(`${AnimationDurations.ENTERING} ${AnimationCurves.ACCELERATION_CURVE}`)),
      transition('* => hidden',
        animate(`${AnimationDurations.LEAVING} ${AnimationCurves.DECELERATION_CURVE}`))
    ])
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastComponent implements OnInit {
  readonly TOAST_CLASS = 'mcrai-toast';

  @HostBinding('@slide') _animation: any = { value: 'void' };

  private _text: string;
  private _offset: string;

  get text(): string {
    return this._text;
  }

  set text(value: string) {
    this._text = value;
  }

  set type(value: string) {
    this._renderer
      .addClass(this._elRef.nativeElement, `${this.TOAST_CLASS}--${value}`);
  }

  set offset(value: string) {
    this._offset = value;
  }

  constructor(
    private _renderer: Renderer2,
    private _elRef: ElementRef
  ) { }

  ngOnInit() {
    this._renderer
      .addClass(this._elRef.nativeElement, this.TOAST_CLASS);
  }

  public open() {
    this._animation = {
      value: 'visible',
      params: {
        offsetY: this._offset
      }
    };
  }

  public close() {
    this._animation = {
      value: 'hidden',
      params: {
        offsetY: this._offset
      }
    };
  }
}
